module.exports = __webpack_public_path__ + "img/0100.3bd54f97.png";